// state
import axios from 'axios'

export const state = {
  questId: false,
  isActive: false,
  progress: 0,
  maxProgress: 5,
  isQuestInviteUsersModalVisible: false,
}

// getters
export const getters = {
  isCompleted: ({ progress, maxProgress }) => progress === maxProgress,
}
// mutations
export const mutations = {
  activateQuest(state, { id, progress }) {
    state.questId = id
    state.isActive = true
    state.progress = progress ? progress / 20 : 0
  },
  deactivateQuest(state) {
    state.isActive = false
    state.progress = 0
    state.isQuestInviteUsersModalVisible = false
  },
  setQuestInviteUsersModalVisibility(state, { isVisible, ...rest }) {
    state.isQuestInviteUsersModalVisible = isVisible
  },
}
// actions
export const actions = {
  async openQuestInviteUsersModal({ commit }, params) {
    commit('setQuestInviteUsersModalVisibility', {
      isVisible: true,
      ...params,
    })
  },
  async closeQuestInviteUsersModal({ commit }) {
    commit('setQuestInviteUsersModalVisibility', { isVisible: false })
  },
  async markQuestSeen({ commit, state: { questId } }) {
    try {
      await axios.post(`quests/markSeen`, {
        quest_id: questId,
      })
      commit('deactivateQuest')
    } catch (e) {

    }
  },
}
